import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { IPlugin, IPluginsStoreState, PluginContext, PluginsActions, UIPluginAttachPoint, filterUIPluginsByAttachPoint } from "@gtmhub/plugins";
import { Item } from "@gtmhub/plugins/components/plugin/plugin.component";
import { reduxStoreContainer } from "@gtmhub/state-management/state-management.module";
import { ReduxStoreObserver } from "@webapp/core/state-management/redux-store-observer";
import { DestroyService } from "@webapp/core/util/services/destroy.service";

@Component({
  selector: "plugins",
  templateUrl: "plugins.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DestroyService],
})
export class PluginsComponent implements OnInit {
  constructor(private pluginsActions: PluginsActions, private changeDetectorRef: ChangeDetectorRef) {}

  @Input()
  public accessPoint: UIPluginAttachPoint | string;
  @Input()
  public context: PluginContext | string;
  @Input()
  public item: Item;

  public pluginsFetched: boolean;
  public plugins: IPlugin[];

  public ngOnInit(): void {
    const { reduxStore } = reduxStoreContainer;
    reduxStore.dispatch(this.pluginsActions.getPlugins());

    const reduxObserver = new ReduxStoreObserver(reduxStore);
    reduxObserver.whenFetched$<IPluginsStoreState>("plugins").subscribe((state) => {
      this.plugins = filterUIPluginsByAttachPoint(state.plugins.items, this.accessPoint);
      this.pluginsFetched = true;
      this.changeDetectorRef.markForCheck();
    });
  }
}
